<template>
	<page>
		<module enable-flex>
			
			<m-operate>
				<c-button power="b_finance_sys_account_add" color="sys" @click="addAccount()">添加账户</c-button>
			</m-operate>
			
			<c-table ref="table" code="finance_sys_account_list">				
				<c-table-column
					label="状态"
					name="state"
				>
					<template v-slot="{data}">
						{{accountStateName[data.state]}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="账户名称"
					name="account_name"
				>
				</c-table-column>
				
				<c-table-column
					label="账户余额"
					name="account_balance"
				>
					<template v-slot="{data}">
						￥{{data.account_balance}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="冻结金额"
					name="frozen_balance"
				>
					<template v-slot="{data}">
						￥{{data.frozen_balance}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="可提现余额"
					name="can_withdraw_balance"
				>
					<template v-slot="{data}">
						￥{{data.can_withdraw_balance}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="保证金额度"
					name="deposit_money"
				>
					<template v-slot="{data}">
						￥{{data.deposit_money}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="保证金余额"
					name="deposit_balance"
				>
					<template v-slot="{data}">
						￥{{data.deposit_balance}}
					</template>
				</c-table-column>


				<c-table-column
					label="待结算金额"
					name="settle_amount"
				>
					<template v-slot="{data}">
						￥{{data.settle_amount}}
					</template>
				</c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="210"
				>
					<template v-slot="{data}">
						<c-table-button @click="edit(data)">编辑</c-table-button>
						<c-table-button power="b_finance_sys_account_del" v-if="data.account_balance == 0 && data.deposit_balance == 0 && data.settle_amount == 0" @click="stateHandle(2,data)">注销</c-table-button>
						<c-table-button v-if="data.state == 1 && (data.account_balance != 0 || data.deposit_balance != 0 || data.settle_amount != 0)" @click="stateHandle(3,data)">挂起</c-table-button>
						<c-table-button v-if="data.state == 3" @click="stateHandle(1,data)">恢复</c-table-button>
						<c-table-button @click="showRecord(data)">查看收支流水</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="editAccount" :title="editState ? '编辑账户' : '新增账户'" width="600" @resolve="submit">
			<c-form ref="form">
				<c-form-item type="hidden" name="id"></c-form-item>
				<c-form-item type="input" label="账户名称" name="account_name" required></c-form-item>
				<c-form-item v-show="!editState" type="input" label="初始化账户余额" name="account_balance" required></c-form-item>
				<c-form-item type="input" label="保证金额度" name="deposit_money" required></c-form-item>
				<c-form-item v-show="!editState" type="input" label="初始化保证金余额" name="deposit_balance" required></c-form-item>
			</c-form>
		</c-dialog>
	</page>
</template>

<script>
	export default {
		name: 'finance_sys_account_list',
		
		data() {
			return {
				accountStateName: {
					1: '正常',
					2: '注销',
					3: '挂起'
				},

				editState: false
			}
		},
		
		mounted() {
			this.$refs.table.load({
				url: '/sys/account/list'
			});
		},
		
		methods: {
			addAccount() {
				this.editState = false;
				this.$refs.form.set({
					id: '',
					account_name: '',
					account_balance: 0,
					deposit_money: 0,
					deposit_balance: 0
				});
				this.$refs.editAccount.open();
			},

			edit(val) {
				this.editState = true;
				this.$refs.form.set(val);
				this.$refs.editAccount.open();
			},

			submit(stop) {
				stop();
				this.$refs.form.submit({
					url: this.editState ? '/sys/account/edit' : '/sys/account/add',
					rule: {
						account_name: [{
							type: 'empty',
							word: '请填写账户名称',
							skip: () => {
								return this.editState;
							}
						}],
						deposit_money: [{
							type: 'empty',
							word: '请填写保证金额度',
							skip: () => {
								return this.editState;
							}
						}],
						account_balance: '请填写初始化账户余额',
						deposit_balance: '请填写初始化保证金余额'
					},
					success: (data, res) => {
						this.$message({
							text: '保存成功'
						});
						this.$refs.table.update();
						this.$refs.editAccount.close();
					}
				});
			},
			
			stateHandle(state, val){
				var text,operation;
				if(state == 2) {
					operation = "注销";
					text = '注销后将删除账户，确定注销[' + val.account_name + ']账户吗？';
				}else if(state == 3) {
					operation = "挂起";
					text = '挂起后账户将不可用，确定挂起[' + val.account_name + ']账户吗？';
				}else{
					operation = "恢复";
					text = '确定恢复[' + val.account_name + ']账户吗？';
				}
				this.$confirm({
					text: text,  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/sys/account/state',
							data: {
								id: val.id,
								state: state
							},
							loading: false,  // 是否显示loading，
							success: data => {
								this.$message({
				                  	text: operation + '成功',
				                  	icon: 'success'
				                });
								this.$refs.table.update();
							},  // 成功回调，接收参数为返回值的obj属性
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			showRecord(val){
				this.navigateTo({
					path: '/sys_account_record/'+val.id,
					query: {
						id: val.id,
						account_name: val.account_name
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	
</style>